/**
 * =================
 * Content Generated RWD BreakPoints
 * relies on css generated content
 * in order to decouple breakpoint definition from JS
 * tool
 * =================
 */
export class CgBreakpoints {
    // staff
    win = window;
    doc = this.win.document;
    el;
    breakPointClass;
    resizeHandler;
    listening = false;
    currBreakPoint;

    constructor() {
        this.init();
    }

    init() {
        this.isMobile();
        this.poll();
    }

    isMobile() {
        var isMobile = this.getBreakpoint();

        return isMobile === "device-small-mobile";
    }

    getBreakpoint() {
        this.el = document.documentElement || this.doc.body;

        if (this.el && this.win.getComputedStyle) {
            return this.win.getComputedStyle(this.el, ':before')
                .getPropertyValue('content')
                .replace(/["']/g, '');
        }
    }

    applyBreakPoint() {
        var el = document.documentElement || document.documentElement.body;
        var currBreakPoint = window.getComputedStyle(el, ':before')
            .getPropertyValue('content')
            .replace(/["']/g, '');

        if (!el) return false;

        el.className = el.className.replace(CgBreakpoints.breakPointClass, '').replace(/^\s+|\s+$/g, ''); // trim it!

        if (currBreakPoint && currBreakPoint !== "none") {
            // bkp class on first position (helps css3 attr selectors)
            el.className = currBreakPoint + " " + el.className;

            // apply onBreakpointChange event
            if (currBreakPoint !== CgBreakpoints.breakPointClass) {
                // @TODO: vanilla event machine (not jQuery)
                $(window.document).trigger("onBreakpointChange", [currBreakPoint]);
            }

            // update class var
            CgBreakpoints.breakPointClass = currBreakPoint;

            // update public currentBkp
            CgBreakpoints.currBreakPoint = currBreakPoint;
        }
    }

    listen(wait, immediate) {
        // flush
        this.flush();

        var handler = wait === 0 && this.applyBreakPoint || _.debounce(this.applyBreakPoint, wait || 250, immediate);

        // first init
        this.applyBreakPoint();

        // add resize event
        window.addEventListener && window.addEventListener("resize",  handler);

        this.listening = true;

        // ret and save named handler to allow later unbinding (flush)
        return this.resizeHandler = handler;
    }

    flush() {
        this.listening = false;
        var handler = this.resizeHandler;
        if (handler && typeof handler === "function") {
            window.removeEventListener && window.removeEventListener("resize", handler);
            this.resizeHandler = null;
        }
    }

    poll() {
        if (this.listening) return;
        this.el = document.documentElement || this.doc.body;

        if (this.el) {
            // watch for CG Breakpoints
            this.listen(0, false);
            return;
        }
        setTimeout(this.poll, 13);
    }
}
